<!--
 * @Description: 秒杀商品列表
 * @Author: kayvor
 * @Date: 2020-03-30 11:27:25
 * @LastEditTime: 2020-04-26 18:01:06
 * @LastEditors: kayvor
 -->

<template>
  <div class="seckillGoodsList-component">
        <seckillSendTips ref="seckillSendTips" @sendState="changeState" />
        <div class="seckillGoodsList goodsList">
            <div class="goods" v-for="(goods, key) of data" :key="key">
                <van-card
                :title="goods.name"
                :thumb="goods.img"
                @click-thumb="goPage(goods)"
                >
                    <div class="prices" slot="desc">
                        <span><i>秒杀价￥</i>{{goods.seckill_price}}</span>
                        <span>￥{{goods.original_price}}</span>
                    </div>
                    <div class="footer" slot="bottom">
                        <span
                        v-if="goods.is_end == 0"
                        >
                            <i v-if="goods.unpaid == 0">还剩{{goods.surplus_repertory}}件</i>
                            <i class="red" v-else>还有车主未支付,还有机会</i>
                        </span>
                        <div class="btn-group" v-if="goods.is_end == 0">
                            <van-button class="grey" type="danger" size="mini" round v-if="goods.unpaid != 0">已结束</van-button>
                            <van-button type="danger" size="mini" round @click="goBuy(goods)" v-else-if="isStart">抢购</van-button>
                            <van-button type="danger" size="mini" round @click="goBuy(goods, 'readyBuy')" v-else-if="!noStart">即将开抢</van-button>
                            <van-button class="orange" type="danger" size="mini" round @click="remindMe(goods)" v-else>{{goods.is_tips ? '取消提醒' : '提醒我'}}</van-button>
                        </div>
                        <div class="btn-group" v-else>
                            <van-button class="grey" type="danger" size="mini" round>已结束</van-button>
                        </div>
                    </div>
                </van-card>
            </div>
        </div>
  </div>
</template>

<script >
import seckillSendTips from '../seckillSendTips/seckillSendTips.vue'
import { cancelRemind } from '@/models/seckill'
import { Card, Toast } from 'vant'
import { qualityImgUrl } from '@/utils/util'

import {
    mapState
} from 'vuex'
export default {
    name: 'seckillGoodsList',
    components : {
        [Card.name]: Card,
        [Toast.name]: Toast,
        seckillSendTips
    },
    data () {
        return {
            goods: {},
            nowTime: 0, // 当前时间
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin,
        }),
        // 是否已开启
        isStart () {
            const { start, end } = this.nowTimeRange
            const startTime = this.now_time - start
            const endTime = this.now_time - end
            return (startTime > 0 && endTime < 0)
        },
        // 是否结束
        isEnd () {
            const { end } = this.nowTimeRange
            const time = this.now_time - end
            return  time >= 0
        },
        // // 即将开抢
        // readyStart () {
        //     // 小于等于5分钟且大于0
        //     return this.countDownTimes <= 300 && this.countDownTimes > 0
        // },
        // 是否未开启
        noStart () {
            const { start } = this.nowTimeRange
            const time = start - this.now_time
            return time > 300
        }
    },
    props: {
        /**
         * 秒杀商品列表数据源
         */
        data: {
            type: Array,
            required: true
        },
        /**
         * 离活动开启分钟
        */
        countDownTimes: {
            type: Number,
            default: 0,
            required: true,
        },
        /**
         * 活动id
         */
        activityId: {
            type: String,
            required: true
        },
        /**
         * 门店id
         */
        sstoreId: {
            type: String,
            required: true
        },
        nowTimeRange: {
            type: Object,
            default: () => {
                return {
                    start: 0,
                    end: 0
                }
            }
        },
        now_time: {
            type: Number,
            default: 0
        },
        javaStoreId: {
            type: String,
            required: true
        },
        // 坐标
        position: {
            type: Object,
            default: () => {
                return {
                    longitude: 113.326233,
                    latitude: 23.197102
                }
            }
        }
    },
    watch: {
        // countDownTimes (newValue, oldValue) {
        //     if (newValue === 0) {
        //         this.data.map(goods => {
        //             goods.is_end = 0
        //         })
        //     }
        // },
        isStart (newValue, oldValue) {
            if (newValue) {
                this.data.map(goods => {
                    goods.is_end = 0
                })
            }
        },
        now_time: {
            handler (newValue, oldValue) {
                this.nowTime = newValue
            }
        },
        data (newValue, oldValue) {
            if (newValue.length !== 0) {
                newValue.forEach(item => {
                    if (item.img) {
                        item.img = qualityImgUrl(item.img, {
                            width: 462,
                            height: 462
                        })
                    }
                })
            }
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
        // 没有门店id就是多店，多店要获取地理位置
        // !this.sstoreId && this.getMyLocation()
    },
    methods: {
        /**
         * 跳转页面
         */
        async goPage (goods) {
            const { spu_id, spec_id, shelf_goods_id, goods_type } = goods
            // 没有门店id跳转秒杀选择门店列表页面，养车app环境中一定会传门店id，所以不在考虑当中
            if (!this.sstoreId) {
                const { latitude, longitude } = this.position
                // 跳转秒杀选择门店页面
                this.$router.push({
                    path: '/seckillStoreList',
                    query: {
                        latitude,
                        longitude,
                        activity_id: this.activityId,
                        spec_id: spec_id,
                    }
                })
            } else if (this.$bridge.isStore()) { // 在养车app环境中
                // 调用跳转原生app方法跳转到商品详情页面
                const { sstoreId, activityId, javaStoreId } = this
                this.$bridge.goAppGoodsDetail({
                    sstore_id: Number(sstoreId || 0),
                    java_storeId: Number(javaStoreId || 0),
                    activity_id: Number(activityId || 0),
                    spu_id: Number(spu_id || 0),
                    goods_id: Number(shelf_goods_id || 0),
                    goods_type
                })
            } else {
                this.$router.push({
                    path: '/goodsDetail',
                    query: {
                        spu_id, // 商品id
                        sstore_id: this.sstoreId, // 门店Id
                        // marketing_id: '', // marketing_id
                        spec_id: spec_id, // 商品规格id
                        goods_type,
                        activity_id: this.activityId, // 活动id
                    }
                })
            }
        },
        /**
         * 提醒我
         */
        remindMe (goods) {
            const { is_tips, id: goods_id } = goods
            this.goods = goods
            const params = {
                sstore_id: this.sstoreId,
                activity_id: this.activityId,
                goods_id
            }
            !is_tips && this.$refs.seckillSendTips.show(params)
            is_tips && this.cancelSend(goods)
        },
        /**
         * 发送短信成功的回调方法
        */
        changeState ({id}) {
            this.goods.is_tips = 1
            this.goods.tips_id = id
        },
        /**
         * 取消短信通知
        */
        async cancelSend (goods) {
            try {
                await cancelRemind({id: goods.tips_id})
                this.goods.is_tips = 0
                this.goods_id = 0
                this.$toast({
                    message: '已取消提醒',
                    position: 'bottom',
                    duration: 3000
                })
            } catch (err) {
                console.error(err)
            }
        },
        /**
         * 抢购按钮一系列判断流程
         */
        goBuy (goods, type = 'readyBuy') {
            // 即将开抢
            if (type === 'readyBuy' && !this.isStart) {
                this.$toast({
                    message: '活动即将开始',
                    position: 'bottom'
                })
                return
            }
            const { spu_id, spec_id, shelf_goods_id, goods_type } = goods
            const query = {
                spu_id,
                spec_id: spec_id,
                sstore_id: this.sstoreId,
                goods_type,
                page_code: 'seckill',
                activity_id: this.activityId,
            }
            if (this.$bridge.isStore()) {
                // 调用跳转原生app方法跳转到商品详情页面
                this.$bridge.goAppGoodsDetail({
                    sstore_id: Number(this.sstoreId || 0),
                    java_storeId: Number(this.javaStoreId || 0),
                    activity_id: Number(this.activityId || 0),
                    spu_id: Number(spu_id || 0),
                    goods_id: Number(shelf_goods_id || 0),
                    goods_type,
                })
            } else if (!this.sstoreId) {
                const { latitude, longitude } = this.position
                // 跳转秒杀选择门店页面
                this.$router.push({
                    path: '/seckillStoreList',
                    query: {
                        latitude,
                        longitude,
                        activity_id: this.activityId,
                        spec_id: spec_id,
                    }
                })
            } else {
                this.$router.push({
                    path: '/goodsDetail',
                    query
                })
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
@import "../../../../assets/stylus/variables";

.seckillGoodsList-component
    width 100%
    margin-top -5px
    background-color $bgGreyColor
    .goodsList
        margin 0 30px
        .goods
            min-height 290px
            background-color #ffffff
            border-radius 10px
            & + .goods
                margin-top 20px
            .prices
                margin-top 40px
                span
                    &:first-child
                        font-size $fontExtraLarge
                        letter-spacing -2px
                        color $fcRed
                    &:last-child
                        font-size $fontSmall
                        line-height 30px
                        color $fcGreyish
                        text-decoration line-through
                        padding-left 6px
                    i
                        font-style normal
                        font-size $fontSmall
                        line-height 36px
                        letter-spacing -1px
                        color $fcRed
            .footer
                height 60px
                > span
                    display inline-block
                    line-height 60px
                    font-size $fontSmall
                    i
                        display inline-block
                        width 172px
                        color $fcGreyish
                        font-style normal
                        &.red
                            line-height 30px
                            color $fcRed
</style>
<style lang="stylus">
@import "../../../../assets/stylus/variables";
.seckillGoodsList
    .van-card
        padding 30px 20px
        background $fcWhite
        border-radius 10px
    .van-card__thumb
        width 230px
        height 230px
        margin-right 25px
        img
            border-radius 0
    .van-card__title
        // height 58px
        // max-height 58px
        max-height none
        font-size $fontBase
        font-weight bold
        line-height 35px
        color $inputTextColor
    .btn-group
        float right
        .van-button
            width 160px
            height 60px
            border-radius 29px
            font-size $fontSmall
            background-image: linear-gradient(90deg,
            #fc2d2d 0%,
            #e60004 100%),
            linear-gradient(
                #fc2d2d,
                #fc2d2d);
            &.orange
                background $fcOrange
                border-color $fcOrange
            &.grey
                background $fcGreyish
                border-color $fcGreyish
</style>
